import React from "react";
import classNames from "classnames";
import "./OutlineStylesContainer.css";

export interface OutlineStylesContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  expanded?: boolean;
}

export function OutlineStylesContainer({
  children,
  expanded,
  ...props
}: React.PropsWithChildren<OutlineStylesContainerProps>) {
  return (
    <div className={classNames("outline-styles-container", { expanded })} {...props}>
      {children}
    </div>
  );
}
